import React, { useEffect } from "react";
import "../nps/NPSModal.css";
import "../nps/EncuestaCorreo.css";

/**
 * Puente de retorno de pagos PSE/Bold para la app movil (app-restaurant-2026, Expo).
 * Bold solo acepta URLs https de retorno: https://{comercio}.sealky.co/payment-return.
 * Esta pagina reenvia al deep link de la app con los mismos query params que agrega Bold
 * (id de la venta y estado), y asi WebBrowser.openAuthSessionAsync cierra el navegador.
 * - El scheme sale del subdominio contra una lista blanca, nunca de un parametro libre.
 * - Subdominio fuera de la lista: mensaje neutro, sin redirigir.
 */

const APP_SCHEMES = {
    "benito-juarez": "benito-juarez",
    "donchicha": "don-chicha",
    "gordales": "gordales",
    "mr-bono": "mr-bono",
    "narcobollo": "narcobollo",
    "woopi": "woopi",
};

function deepLink() {
    const scheme = APP_SCHEMES[window.location.hostname.split(".")[0]];
    return scheme ? `${scheme}://payment-return${window.location.search}` : null;
}

export function PaymentReturn() {
    const link = deepLink();

    useEffect(() => {
        if (link) window.location.replace(link);
    }, [link]);

    return (
        <div className="encuesta-page">
            <div className="encuesta-card">
                <div className="nps-thanks">
                    {link ? (
                        <>
                            <h2 className="nps-thanks-title">Volviendo a la app…</h2>
                            <p className="nps-thanks-sub">Si no vuelves automáticamente, toca el botón.</p>
                            <a className="btn btn-dark mt-3" href={link}>Volver a la app</a>
                        </>
                    ) : (
                        <>
                            <h2 className="nps-thanks-title">Pago procesado</h2>
                            <p className="nps-thanks-sub">Ya puedes cerrar esta ventana.</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
